var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84961 12.0001C2.84961 6.94669 6.9462 2.8501 11.9996 2.8501C17.053 2.8501 21.1496 6.94669 21.1496 12.0001V20.4001C21.1496 20.8143 20.8138 21.1501 20.3996 21.1501H17.9996C16.9227 21.1501 16.0496 20.2771 16.0496 19.2001V16.8001C16.0496 15.7231 16.9227 14.8501 17.9996 14.8501H19.6496V12.0001C19.6496 7.77512 16.2246 4.3501 11.9996 4.3501C7.77463 4.3501 4.34961 7.77512 4.34961 12.0001V14.8501H5.99961C7.07656 14.8501 7.94961 15.7231 7.94961 16.8001V19.2001C7.94961 20.2771 7.07656 21.1501 5.99961 21.1501H3.59961C3.1854 21.1501 2.84961 20.8143 2.84961 20.4001V12.0001ZM4.34961 16.3501V19.6501H5.99961C6.24814 19.6501 6.44961 19.4486 6.44961 19.2001V16.8001C6.44961 16.5516 6.24814 16.3501 5.99961 16.3501H4.34961ZM19.6496 16.3501H17.9996C17.7511 16.3501 17.5496 16.5516 17.5496 16.8001V19.2001C17.5496 19.4486 17.7511 19.6501 17.9996 19.6501H19.6496V16.3501Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/Headset.47a9aa36bf4022aa6ec9475bcb7ec4f8.svg";
export { ForwardRef as ReactComponent };